import React from 'react';
import FormItem from '../FormItem';
import { FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import FormErrorMessage from '@/helpers/formErrorMessages';
import { AgentDetailModel } from '@/__generated';
import { useTranslation } from 'react-i18next';

type Props = {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  watch: UseFormWatch<any>;
  profile?: AgentDetailModel | undefined | null;
};

export default function CompanyLicenseForm({ register, errors, watch }: Props) {
  const { t } = useTranslation();
  const haveLicense = watch('haveLicense');
  return (
    <>
      {/* End .col */}
      <div className="col-12 d-flex align-items-center">
        <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
        <div className="fw-bold text-18 text-blue-1  rounded-2 px-10 text-uppercase">{t('agentRegister_DoYouHaveLicense')}</div>
        <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
      </div>

      <div className="col-12">
        <div className="form-item-radio no-border px-0">
          <label className={`lh-1 text-14 text-light-1 label`}>Do you have any license?</label>
          <div className="d-flex radio-container">
            <div className="d-flex items-center radio-item">
              <input {...register('haveLicense', { required: true })} type="radio" value="Yes" id="haveLicenseYes" />
              <label htmlFor="haveLicenseYes">{t('base.Yes')}</label>
            </div>
            <div className="d-flex items-center radio-item">
              <input {...register('haveLicense', { required: true })} type="radio" value="No" id="haveLicenseNo" />
              <label htmlFor="haveLicenseNo">{t('base.No')}</label>
            </div>
          </div>
        </div>
      </div>
      {haveLicense !== 'No' ? (
        <>
          <div className="col-12">
            <div className="mb-3">
              <label htmlFor="licenseFiles" className="lh-1 text-14 text-light-1 label form-label">
                {t('agentRegister_TravelAgentLicenseFile')}
              </label>
              <input
                id="licenseFiles"
                type="file"
                {...register('licenseFiles', { required: true })}
                multiple
                className="form-control"
                accept="image/*,.pdf,.doc,.docx"
              />
              <ErrorMessage errors={errors} name="licenseFiles" message={FormErrorMessage.Required} as="span" className="form-item-error" />
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
